import Footer from "../components/Footer/Footer";
import {
  FaWhatsapp,
  FaPhone,
  FaDumbbell,
  FaPersonRunning,
  FaBolt,
  FaFire,
  FaTrophy,
  FaHeartPulse,
  FaUserNinja,
  FaCalendarCheck,
  FaScaleBalanced,
  FaMedal,
  FaClock,
} from "react-icons/fa6";

// 6 Service Images from src/images/classes
import weightTrainingImg from "../images/trainings/weight-lifting-training.jpg";
import cardioImg from "../images/trainings/conditioning_training.jpeg";
import strengthImg from "../images/trainings/strength_image.jpg";
import functionalImg from "../images/trainings/functional_image.jpg";
import transformationImg from "../images/trainings/body_transforming.jpg";
import lifestyleImg from "../images/trainings/lifestyle.jpg";
import coachNandhaImg from "../images/who-we-are/nandhu.png";

function Trainings() {
  const services = [
    {
      title: "Weight Training",
      desc: "Build strength, tone muscles, and increase bone density with free weights, barbells, and pin-selected machine training.",
      img: weightTrainingImg,
      Icon: FaDumbbell,
      tag: "Muscle Building",
    },
    {
      title: "Cardio Conditioning",
      desc: "Boost your stamina and heart health with our premium commercial treadmills, spin bikes, and low-impact ellipticals.",
      img: cardioImg,
      Icon: FaPersonRunning,
      tag: "Endurance & Heart",
    },
    {
      title: "Strength & Conditioning",
      desc: "Targeted athletic conditioning designed to enhance overall explosive power, joint mobility, and sports performance.",
      img: strengthImg,
      Icon: FaBolt,
      tag: "Athletic Performance",
    },
    {
      title: "Functional Fitness",
      desc: "Improve your daily strength, agility, and flexibility using cross-training rigs, kettlebells, and battle ropes.",
      img: functionalImg,
      Icon: FaFire,
      tag: "Core & Agility",
    },
    {
      title: "Body Transformation",
      desc: "Customized intensive routines focused on rapid fat loss, lean muscle definition, and lasting body recomposition.",
      img: transformationImg,
      Icon: FaTrophy,
      tag: "Fat Loss & Gains",
    },
    {
      title: "Lifestyle Coaching",
      desc: "Holistic coaching on daily habit building, sleep hygiene, hydration, and science-backed nutrition guidance for lasting vitality.",
      img: lifestyleImg,
      Icon: FaHeartPulse,
      tag: "Habits & Nutrition",
    },
  ];

  const programs = [
    {
      name: "Personal Training (PT)",
      duration: "Flexible Timing",
      detail: "One-on-one custom guidance from certified head coach G. Nandha Kumar with custom diet charts and regular assessments.",
      Icon: FaUserNinja,
      badge: "Most Popular",
    },
    {
      name: "General Fitness Program",
      duration: "Daily Access",
      detail: "General gym floor guidance, progressive workout templates, form check, and routine motivation.",
      Icon: FaCalendarCheck,
      badge: "Standard",
    },
    {
      name: "Weight Loss / Gain Program",
      duration: "12-Week Course",
      detail: "A target-driven structured program featuring tailored calorie-deficit/surplus diets and body composition tracking.",
      Icon: FaScaleBalanced,
      badge: "Goal Driven",
    },
    {
      name: "Athletic Prep Program",
      duration: "Custom Timeline",
      detail: "Advanced periodized strength routines for stage preparation, bodybuilding competitions, or specific sports.",
      Icon: FaMedal,
      badge: "Advanced",
    },
  ];

  return (
    <>
      <section className="bg-black text-white min-h-screen">
        {/* Hero Banner */}
        <div className="login-banner relative justify-center flex bg-brand-yellow">
          <h1 className="text-black absolute bottom-[20px] sm:bottom-[25px] text-[26px] sm:text-[34px] md:text-[40px] font-extrabold uppercase text-center px-4">
            Training Programs
          </h1>
        </div>

        {/* Introduction */}
        <div className="container page-padding py-12 sm:py-16 md:py-20 text-center max-w-4xl">
          <span className="inline-block text-[#ff0336] text-[11px] sm:text-[12px] font-bold uppercase tracking-[3px] mb-3">
            ★ Results-Driven Methodology
          </span>
          <h2 className="text-[24px] sm:text-[30px] md:text-[36px] font-extrabold mb-4 sm:mb-6 text-brand-yellow">
            Science-Backed Training &amp; Professional Coaching
          </h2>
          <p className="text-neutral-400 text-[14px] sm:text-[16px] leading-relaxed">
            At <span className="text-brand-yellow font-bold">FAT2FIT Unisex Fitness Centre</span>, our training is tailored around individual body composition, capacity, and objectives. Under the guidance of our Internationally Certified head trainer, we offer a range of programs for all fitness levels.
          </p>
        </div>

        {/* 1. Services with 6 Images */}
        <div className="bg-[#111] py-12 sm:py-16 md:py-20">
          <div className="container page-padding">
            <h2 className="text-[24px] sm:text-[28px] md:text-[32px] font-bold text-center mb-12 sm:mb-16 relative">
              Our Fitness Services
              <span className="w-[80px] h-[4px] bg-[#ff0336] absolute -bottom-3 left-1/2 -translate-x-1/2"></span>
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {services.map((svc, i) => (
                <div
                  key={i}
                  className="group bg-black rounded-2xl border border-neutral-800 overflow-hidden hover:border-brand-yellow transition-all duration-500 shadow-xl hover:shadow-[0_10px_35px_rgba(255,214,0,0.12)] hover:-translate-y-1.5 flex flex-col justify-between"
                >
                  {/* Service Image Container */}
                  <div>
                    <div className="relative h-[220px] sm:h-[240px] overflow-hidden">
                      <img
                        src={svc.img}
                        alt={svc.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                      {/* Gradient overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-300"></div>

                      {/* Top Badges */}
                      <div className="absolute top-3 left-3 flex items-center gap-2">
                        <span className="bg-[#ff0336] text-white text-[10px] sm:text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow">
                          {svc.tag}
                        </span>
                      </div>

                      {/* Icon overlay button */}
                      <div className="absolute bottom-3 right-3 w-10 h-10 bg-neutral-900/90 border border-neutral-700 rounded-full flex items-center justify-center text-brand-yellow text-[16px] group-hover:bg-brand-yellow group-hover:text-black transition-colors duration-300">
                        <svc.Icon />
                      </div>
                    </div>

                    {/* Service Content */}
                    <div className="p-6">
                      <h3 className="text-[19px] sm:text-[21px] font-bold mb-2.5 text-white group-hover:text-brand-yellow transition-colors duration-300">
                        {svc.title}
                      </h3>
                      <p className="text-neutral-400 text-[13px] sm:text-[14px] leading-relaxed">
                        {svc.desc}
                      </p>
                    </div>
                  </div>

                  {/* Bottom Accent */}
                  <div className="px-6 pb-6 pt-0">
                    <div className="w-full h-[2px] bg-neutral-800 group-hover:bg-brand-yellow transition-colors duration-300"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 2. Training Programs Offered */}
        <div className="py-12 sm:py-16 md:py-20">
          <div className="container page-padding">
            <h2 className="text-[24px] sm:text-[28px] md:text-[32px] font-bold text-center mb-12 sm:mb-16 relative">
              Programs Offered
              <span className="w-[80px] h-[4px] bg-brand-yellow absolute -bottom-3 left-1/2 -translate-x-1/2"></span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16">
              {programs.map((prog, i) => (
                <div
                  key={i}
                  className="bg-[#111] p-6 sm:p-8 border-l-4 border-[#ff0336] rounded-r-2xl flex flex-col justify-between shadow-lg hover:border-brand-yellow transition-all duration-300 group border-y border-r border-neutral-900"
                >
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-brand-yellow uppercase text-[11px] sm:text-[12px] font-bold tracking-widest flex items-center gap-1.5">
                        <FaClock className="text-[11px]" /> {prog.duration}
                      </span>
                      <span className="bg-neutral-800 text-neutral-300 text-[10px] sm:text-[11px] font-semibold px-2.5 py-0.5 rounded-full">
                        {prog.badge}
                      </span>
                    </div>
                    <h3 className="text-[20px] sm:text-[22px] font-bold my-2 text-white group-hover:text-brand-yellow transition-colors duration-300 flex items-center gap-2.5">
                      <prog.Icon className="text-[#ff0336] text-[17px]" />
                      {prog.name}
                    </h3>
                    <p className="text-neutral-400 text-[13.5px] sm:text-[14px] leading-relaxed mt-2">
                      {prog.detail}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Personal Training Callout with Coach Nandha */}
            <div className="bg-[#111] border border-neutral-800 rounded-3xl p-6 sm:p-10 md:p-12 max-w-4xl mx-auto mt-8 sm:mt-12 relative overflow-hidden shadow-2xl">
              {/* Slanted decoration bar */}
              <div className="absolute top-0 left-0 w-full h-[6px] bg-brand-gradient"></div>

              <div className="flex flex-col md:flex-row items-center gap-8 md:gap-10">
                {/* Coach Photo */}
                <div className="relative flex-shrink-0">
                  <div className="w-32 h-32 sm:w-40 sm:h-40 rounded-2xl overflow-hidden border-2 border-brand-yellow shadow-xl bg-neutral-900">
                    <img
                      src={coachNandhaImg}
                      alt="Coach G. Nandha Kumar"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <span className="absolute -bottom-2 -right-2 bg-[#ff0336] text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider shadow">
                    Head Coach
                  </span>
                </div>

                {/* Content */}
                <div className="text-center md:text-left flex-1">
                  <span className="text-[#ff0336] text-[11px] sm:text-[12px] font-bold uppercase tracking-[2px] block mb-1">
                    Mr. India Junior &amp; Mr. Tamil Nadu Champion
                  </span>
                  <h3 className="text-[22px] sm:text-[26px] md:text-[28px] font-bold mb-3 text-brand-yellow">
                    Elite 1-on-1 Personal Training by G. Nandha Kumar
                  </h3>
                  <p className="text-[13.5px] sm:text-[15px] text-neutral-300 mb-6 leading-relaxed">
                    Unlock your true athletic potential. Get custom-tailored diet templates, periodized workout structures, weekly body measurements, and professional form correction directly from champion coaching.
                  </p>

                  <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center md:justify-start">
                    <a
                      href="https://wa.me/918637488702?text=Hi%20Nandha%2C%20I%20want%20to%20know%20more%20about%20your%20Personal%20Training%20program!"
                      target="_blank"
                      rel="noreferrer"
                      className="bg-brand-yellow text-black font-bold uppercase text-[13px] sm:text-[14px] px-6 sm:px-8 py-3.5 sm:py-4 inline-flex items-center justify-center gap-2 hover:bg-[#ff0336] hover:text-white transition duration-300 rounded-xl shadow-lg"
                    >
                      <FaWhatsapp className="text-lg" /> Inquire About PT
                    </a>
                    <a
                      href="tel:8637488702"
                      className="border-2 border-neutral-700 text-white hover:border-brand-yellow hover:text-brand-yellow font-bold uppercase text-[13px] sm:text-[14px] px-6 sm:px-8 py-3.5 sm:py-4 inline-flex items-center justify-center gap-2 transition duration-300 rounded-xl"
                    >
                      <FaPhone className="text-sm" /> Call Coach
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </section>
    </>
  );
}

export default Trainings;
